import {MDBBadge} from "mdbreact";
import React from "react";

function ProjectCardBadge(props) {
	return (
		<MDBBadge pill color={props.color} className="category-badge">{props.text}</MDBBadge>
	)
}
export default ProjectCardBadge;
